import { render, staticRenderFns } from "./UniInfoCard.vue?vue&type=template&id=2f228cf8&scoped=true&"
import script from "./UniInfoCard.vue?vue&type=script&lang=js&"
export * from "./UniInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./UniInfoCard.vue?vue&type=style&index=0&id=2f228cf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f228cf8",
  null
  
)

export default component.exports